/**************************************************************************
Name:         main.js
Description:  Main site scripting
Date Created: 04/10/2019
**************************************************************************/

//homepage meetings - region filters
var setMeetingsByRegion = function()
{
	$( '.eventshome-item' ).hide().removeClass('active');
	$( '.eventshome-month' ).hide();
	$( '.homecalendar-link' ).removeClass('active');

	if( $(".regionCheckbox:checked").length > 0 )
	{
		$.each($(".regionCheckbox:checked"), function(){
			var regionUUID =  $(this).val();
			$( '.eventshome-item[data-regionuuid='+ regionUUID +']' ).show();
	    });
	}
    else
    {
    	$( '.eventshome-item' ).show();
    }

    $('.eventshome-item:visible:gt(5)').hide();

    $('.eventshome-item:visible:eq(0)').addClass('active');

    var activeEventUUID = $('.eventshome-item:visible:eq(0)').attr('data-eventuuid');
    $( '.homecalendar-link[data-eventuuid='+ activeEventUUID +']' ).addClass('active');

    $.each($(".eventshome-month"), function(){
		// Using month-row because otherwise if a month is in the query twice, but only one of them has active events, the inactive month will still display on the page,
		// because there are visible events with the matching month number. Switching to month-row ensures that the code is only looking at the events associated with
		// the correct month.

		//OLD CODE:
		//var month =  $(this).attr('data-month');
		//var visible = $( '.eventshome-item[data-month-row='+ month +']:visible' ).length;

		//NEW CODE:
		var monthRow = $(this).attr('data-month-row');
		var visible = $( '.eventshome-item[data-month-row='+ monthRow +']:visible' ).length;

		if( visible > 0 )
			$(this).show();
    });
};

var sponsorImageIndex = 1;
var setSponsorImages = function()
{
	var imageNum = $( '.homesponsor-img' ).length;

	if( sponsorImageIndex < imageNum)
		$('.homesponsor-img[data-index='+ sponsorImageIndex +']').addClass('transparent');
	else
		$( '.homesponsor-img' ).removeClass('transparent');

	if( sponsorImageIndex < imageNum)
		sponsorImageIndex++;
	else if( sponsorImageIndex == imageNum)
		sponsorImageIndex = 1;
}

if( isHomepage == true )
	setInterval(setSponsorImages, 3000);

var sponsorCalendarIndex = 1;
var setSponsorCalendarImages = function()
{
	var imageNum = $( '.eventshome-images.active .eventshome-img2' ).length;

	if( sponsorCalendarIndex < imageNum)
		$('.eventshome-images.active .eventshome-img2[data-index='+ sponsorCalendarIndex +']').parent().addClass('transparent');
	else
		$( '.eventshome-images.active .eventshome-img2-container' ).removeClass('transparent');

	if( sponsorCalendarIndex < imageNum)
		sponsorCalendarIndex++;
	else if( sponsorCalendarIndex == imageNum)
		sponsorCalendarIndex = 1;
}

if( isHomepage == true )
	setInterval(setSponsorCalendarImages, 3000);

var sponsorImageSizes = function()
{
	//Sponsor images
	var imgWidth = $( '.homesponsor-img.first' ).width();
	var imgHeight = $( '.homesponsor-img.first' ).height();

	$.each($(".homesponsor-img").not('.first'), function(){
		$(this).height(imgHeight);
    });
}

var setNewsCarousell = function()
{
	$('.articlehome3-slidecontainer').css('min-height', $('.articlehome3-slide.active').height() - 10 + 'px' );
}

if( isHomepage == true )
{
	sponsorImageSizes();

	$( window ).resize(function() {
		sponsorImageSizes();

		//News Carousell
		setNewsCarousell();
	});

	// Firefox page refresh fix
	setTimeout(function() {
		setNewsCarousell();
	}, 100);
}

$(function() {

	//Login modal
	$( '#loginLink' ).on( 'click', function( ){
		event.preventDefault();
		$( '.homemodal-container' ).addClass('active');
		$( '#loginUser' ).focus();
	});

	$( '.homemodal-close' ).on( 'focus', function( ){
		$( '.homemodal-container' ).removeClass('active');
		$( '#loginLink' ).focus();
	});

	//Mobile navigation
	$( '.primarynav-icon' ).on( 'click', function( ){
		event.preventDefault();
		$( '.l-primarynav' ).toggleClass('navactive');
		$( '.primarynav' ).toggleClass('navactive');
		$( '.primarynav-logo' ).toggleClass('logoactive');

		$( '.primarynav-dropdown' ).removeClass('active');

		$( '.homesponsor' ).toggle();
	});

	//Desktop navigation
	$( '.primarynav-button' ).on( 'click', function( ){
		window.location = $(this).attr('data-href');
	});

	//homepage meetings and events
	$( '.eventshome-item' ).on( 'click focus', function( ){
		$( '.eventshome-item' ).removeClass('active');
		$( this ).addClass('active');

		$( '.homecalendar-link' ).removeClass('active');
		var activeEventUUID = $( this ).attr('data-eventuuid');
	    $( '.homecalendar-link[data-eventuuid='+ activeEventUUID +']' ).addClass('active');

	    //Images
	    sponsorCalendarIndex = 1;
	    $( '.eventshome-images .eventshome-img2-container' ).removeClass('transparent');

	    $( '.eventshome-images' ).removeClass('active');

	    var img1 = $( '.eventshome-images[data-eventuuid='+ activeEventUUID +'] .eventshome-img' );
	    if( img1.attr('src') != img1.attr('data-src') )
	   		img1.attr('src', img1.attr('data-src'));

	    $.each($( '.eventshome-images[data-eventuuid='+ activeEventUUID +'] .eventshome-img2' ), function(){

			if( $( this ).attr('src') != img1.attr('data-src') )
				$( this ).attr('src', $( this ).attr('data-src'));

	    });

	    $( '.eventshome-images[data-eventuuid='+ activeEventUUID +']' ).addClass('active').addClass('fadeInFromNone');
	});

	$( '.regionCheckbox' ).on( 'click', function( ){
		setMeetingsByRegion();
	});

	$( '.primarynav-expand' ).on( 'click', function( ){
		event.preventDefault();
		var currentActive = $(this).parent().parent().find('.active')[0];
		var parent = $(this).parent()[0]

		if (currentActive != parent) {
			$(currentActive).removeClass('active');
		}
		 $(parent).toggleClass('active');
	});

	// $( '.primarynav-expand' ).on('mouseenter', function() {
	// 	event.preventDefault();
	// 	var parent = $(this).parent()[0];
	//  	$(parent).addClass('active');
	// });

	// $( '.primarynav-expand' ).on('mouseleave',  function() {
	// 	event.preventDefault();
	// 	var parent = $(this).parent()[0];
	//  	$(parent).removeClass('active');
	// });

	$( '.articlehome3-circle' ).on( 'click', function( ){
		$('.articlehome3-circle').removeClass('active');
		$(this).addClass('active');

		var slideIndex = $(this).attr('data-index');

		$('.articlehome3-slide').removeClass('active');
		$('.articlehome3-slide[data-index='+ slideIndex +']').addClass('active');

		//News Carousell
		setNewsCarousell();
	});

	//Event search
	$( '#eventSearchOptions' ).on( 'click', function( ){
		$('.eventSearchFilters .searchFilters').toggleClass('active');
	});

	if( isHomepage == true )
	{
		$('.l-loginbarbg').height( $('.loginbar').height() );
	}

	$( window ).resize(function() {
		if( $(window).width() > 768 ) {
			var headerElem = $('header.column.span_1_1.l-primarynav.group');
			if(headerElem.hasClass('navactive')) {
				$(headerElem).removeClass('navactive');
			}

			var primaryNav = $('.primarynav');
			if(primaryNav.hasClass('navactive')) {
				$(primaryNav).removeClass('navactive');
			}

			var logo = $('a.primarynav-logo');
			if(logo.hasClass('logoactive')) {
				$(logo).removeClass('logoactive');
			}
		}
	});

});

/* Google Analytics event tracking */
var trackGaEvent = function(eventAction, urlAction, url, eventLabel, eventCategory, eventValue) {
	// Standard callback
	function analyticsCallback() {
		if(urlAction != undefined && url != undefined && url.length > 0) {
			if(urlAction == 'openWindow') window.open( url );
			else window.location = url;
		}
	}

	$.ajax({
		url      : '/cfcs/pageGW.cfc',
		data     : {
			method : 'getGaEventTrackingAJAX'
		},
		cache    : false,
		dataType : 'json',
		success  : function( result )
		{
			if(result.TRACK) {
				ga('send', {
					'hitType': 'event',
					'eventCategory': eventCategory,
					'eventAction': eventAction,
					'eventLabel': eventLabel,
					'eventValue': eventValue,
					'hitCallback': analyticsCallback
				});
			} else {
				analyticsCallback();
			}

			if (result.SHOWAVIBE) {
				console.log("****** A-VIBE Only -- Google Analytics event tracking code ******");
				console.log("ga('send', { hitType: 'event', eventCategory: " + eventCategory + ", eventAction: " + eventAction + ", eventLabel: " + eventLabel + ", eventValue: " + eventValue + " });");
			}
		},
		error : function( jqXHR, status, thrown )
		{
			$.ajax({
				url  : '/cfcs/pageDAO.cfc',
				data : {
					method : 'gaEventTrackingErrorAJAX',
					status : status,
					thrown : thrown
				},
				cache    : false,
				dataType : 'json'
			});

			if(urlAction != undefined && url != undefined && url.length > 0) {
				if(urlAction == 'openWindow') window.open( url );
				else window.location = url;
			}
		}
	});
}
